import { Card } from "@ui/Card";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { HStack, VStack } from "@ui/Stack";
import { Text } from "@ui/typography/Text";
import "@ui/Button.css";
import "./DiscoveryNewQuestionCard.css";

const NEW_QUESTION_HREF = "/";

export const DiscoveryNewQuestionCard = () => {
	return (
		<Card
			as="a"
			href={NEW_QUESTION_HREF}
			theme="mint-grad"
			class="discovery-new-question-card"
			aria-label="Have a question? Ask it"
		>
			<HStack
				align="center"
				spacing="large"
				justify="space-between"
				class="discovery-new-question-card__row"
			>
				<HStack
					align="center"
					spacing="large"
					class="discovery-new-question-card__lead"
				>
					<span class="discovery-new-question-card__icon" aria-hidden="true">
						<MaterialSymbol
							symbol="edit_square"
							color="white"
							relativeSize={1.35}
						/>
					</span>
					<VStack spacing="small" align="start">
						<Text as="h2" size="intermediate" weight="bold" color="ink">
							Have a question? Ask it
						</Text>
						<Text size="standard" color="fg3">
							Answers come from the creators you subscribe to, with the clips
							they're in
						</Text>
					</VStack>
				</HStack>
				<span
					class="gvtui-button gvtui-button--large primary discovery-new-question-card__cta"
					aria-hidden="true"
				>
					<div>
						<span class="gvtui-button-link__content">New question</span>
						<MaterialSymbol symbol="arrow_forward" relativeSize={1.14} />
					</div>
				</span>
			</HStack>
		</Card>
	);
};
